import React, { useState, Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha";
import { Alert } from 'react-bootstrap';
import { AppContext } from '../../../AppContext';

const Content = () => {
    const { appState, setAppState } = useContext(AppContext);
    const {
        contactus = {
            heading: 'Contact Us',
            subtext: "Still have questions? Our Client Success Team is always here to help",
            header: "Get In Touch",
            details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
            content: [
                {
                    icon: "fas fa-phone-alt",
                    title: "Phone",
                    text: "Start working with LOANLY that can provide everything",
                    info: "+(347)123 456 7890",
                },
                {
                    icon: "far fa-envelope",
                    title: "Email",
                    text: "Start working with LOANLY that can provide everything",
                    info: "contact@example.com",
                },
                {
                    icon: "fas fa-map-marker-alt",
                    title: "Location",
                    text: "Start working with LOANLY that can provide everything",
                    info: "View on Google map",
                },
            ],
            formFields: [
                { name: "name", label: "Full Name", type: "text", placeholder: "Full Name" },
                { name: "email", label: "Email Address", type: "email", placeholder: "Email Address" },
                { name: "phone", label: "Phone No.", type: "text", placeholder: "Phone No." },
                { name: "subject", label: "Subject", type: "text", placeholder: "Subject" },
                { name: "message", label: "Message", type: "textarea", placeholder: "Write Something" },
            ],
            success: "Success! Contact form has been successfully submitted.",
            errorMessage: "Oops!</strong> Something bad happened. Please try again later"
        }

    } = appState;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const [formStatus, setFormStatus] = useState({ success: false, error: false });




    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Mock success behavior
        if (formData.name && formData.email && formData.message) {
            setFormStatus({ success: true, error: false });
        } else {
            setFormStatus({ success: false, error: true });
        }
    };

    const handleCaptcha = (value) => {
        console.log("Captcha value:", value);
    };

    return (
        <Fragment>
            <section className="section-padding bg-gray contact-us" id={'contactus'}>

                <div className="container">
                    <div className="section-header">
                        <div className="section-heading">
                            <h3 className="text-custom-black fw-700">{contactus.heading}</h3>
                            <div className="section-description">
                                <p className="text-light-white no-margin">{contactus.subtext}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-5 col-lg-4 mb-md-80">
                            <div className="contact-form full-height align-self-center bx-wrapper bg-custom-white">
                                <h4 className="text-custom-black fw-600">{contactus?.header}</h4>
                                <p className="text-light-white no-margin">
                                    {contactus?.details}
                                </p>
                                <form className="form-layout-1" onSubmit={handleSubmit} method="GET">
                                    <div className="row">
                                        {contactus?.formFields.map((field, idx) => (
                                            <div key={idx} className={`col-sm-6 ${field.name === 'message' ? 'col-12 mb-xl-20' : ''}`}>
                                                <div className="form-group">
                                                    <label className="text-left">{field.label}</label>
                                                    {field.type === "textarea" ? (
                                                        <textarea
                                                            rows={5}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            placeholder={field.placeholder}
                                                            required
                                                        />
                                                    ) : (
                                                        <input
                                                            type={field.type}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            placeholder={field.placeholder}
                                                            required
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-12">
                                            <ReCAPTCHA
                                                sitekey="6LdxUhMaAAAAAIrQt-_6Gz7F_58S4FlPWaxOh5ib"
                                                onChange={handleCaptcha}
                                                size="invisible"
                                            />
                                            <button type="submit" className="btn-first btn-submit text-light-blue full-width">Submit</button>

                                            {formStatus.success && (
                                                <Alert variant="success" className="mt-3 mb-0">
                                                    {contactus?.success}
                                                </Alert>
                                            )}
                                            {formStatus.error && (
                                                <Alert variant="danger" className="mt-3 mb-0">
                                                    {contactus?.errorMessage}
                                                </Alert>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-8">
                            <iframe
                                className="full-width full-height"
                                title="map"
                                src="https://maps.google.com/maps?q=university%20of%20san%20francisco&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-padding bg-gray contact-bottom">
                <div className="container">
                    <div className="row">
                        {contactus?.content.map((item, i) => (
                            <div key={i} className="col-lg-4 col-sm-6">
                                <div className="contact-info bx-wrapper bg-custom-white text-center mb-md-40">
                                    <div className="contact-info-wrapper">
                                        <div className="icon mb-xl-20"><i className={item.icon} /></div>
                                        <h5 className="text-custom-black fw-600">{item.title}</h5>
                                        <p className="text-light-white">{item.text}</p>
                                        <Link to="#" className="fs-14">{item.info}</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default Content;
